import React, {useEffect, useState} from "react";
import {useSnackbar} from "notistack";
import ConfirmDialog from "../../ConfirmDialog";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import {useDeleteTravelExpenseMutation} from "../../../services/authService";
import messages from "../../../utils/messages";
import styles from "../Travel.module.scss";

const DeleteTravelExpense = ({ id, disabled, onDelete }) => {
    const [open, setOpen] = useState(false);
    const [deleteTravelExpense, { isSuccess, error, reset }] = useDeleteTravelExpenseMutation();
    const { enqueueSnackbar } = useSnackbar();

    const handleOpen = () => {
        setOpen(true);
    }

    const handleDelete = () => {
        console.log('id');
        deleteTravelExpense(id);
    }

    const handleMessages = () => {
        if(isSuccess){
            enqueueSnackbar(`${messages.success.deleteTravelExpense}`, { variant: 'success' });
            reset();
            onDelete();
        }
        if(error){
            enqueueSnackbar(`${messages.error.prefix} ${error?.data[0]?.errorMessage}`, { variant: 'error' });
        }
    }

    useEffect(() => {
        if(isSuccess || error){
            handleMessages();
        }
        // eslint-disable-next-line
    }, [isSuccess, error]);

    if(disabled){
        return <></>
    }

    return (
        <>
            <DeleteOutlinedIcon
                fontSize="small"
                onClick={handleOpen}
                className={`${styles.icon}`}
            />
            <ConfirmDialog
                title={`Delete Travel Expense`}
                open={open}
                setOpen={setOpen}
                onConfirm={handleDelete}
            >
                { messages.confirm.deleteTravelExpense }
            </ConfirmDialog>
        </>
    )
}

export default DeleteTravelExpense;
